import React, { Component } from 'react'
import './Bloc.css'
import { connect } from 'react-redux'
import { EligibilitePtz } from '../../engine/ApiCommunicator'

class BlocEligibilitePTZ extends Component {
    constructor(props) {
        super(props)
        this.state = { objectInfoPTZ: null}
        this.CallEligibilitePtz = this.CallEligibilitePtz.bind(this)
    }

    DataMonitored() {
        var zone = this.props.prj_localisation_ville
            ? this.props.prj_localisation_ville.ptz
            : null
        var type_projet = this.props.prj_type ? this.props.prj_type : null
        var type_log = this.props.type_log ? this.props.type_log : null
        var nombre_occupant = this.props.emp_nb_personnes_foyer
            ? this.props.emp_nb_personnes_foyer
            : 2
        var revenu_fiscaux = this.props.finance_revenu_fiscal_ref
            ? this.props.finance_revenu_fiscal_ref * 100
            : null
        var travaux = this.props.prj_montant_travaux
            ? this.props.prj_montant_travaux * 100
            : 0
        var cout_operation =
            (this.props.prj_montant_travaux
                ? this.props.prj_montant_travaux
                : 0) +
            (this.props.prj_montant_construction
                ? this.props.prj_montant_construction
                : 0) +
            (this.props.prj_montant_terrain
                ? this.props.prj_montant_terrain
                : 0) +
            (this.props.prj_montant_frais_agence
                ? this.props.prj_montant_frais_agence
                : 0) +
            (this.props.prj_montant_frais_divers
                ? this.props.prj_montant_frais_divers
                : 0) +
            (this.props.prj_montant_achat ? this.props.prj_montant_achat : 0)
        if (
            zone !== null &&
            type_projet !== null &&
            revenu_fiscaux !== null &&
            cout_operation !== null
        ) {
            return {
                zone: zone,
                type_projet: type_projet,
                type_log: type_log,
                nombre_occupant: nombre_occupant,
                revenu_fiscaux: revenu_fiscaux,
                travaux: travaux,
                cout_operation: cout_operation * 100,
            }
        }
        return undefined
    }
    FieldUpdated() {
        if (
            JSON.stringify(this.DataMonitored()) !==
            JSON.stringify(this.state.objectInfoPTZ)
        ) {
            return true
        } else {
            return false
        }
    }

    CallEligibilitePtz() {
        var dataToSend = this.DataMonitored()
        if (dataToSend !== undefined) {
            this.setState({
                objectInfoPTZ: dataToSend,
            })
            EligibilitePtz(
                dataToSend.type_projet,
                dataToSend.nombre_occupant,
                dataToSend.revenu_fiscaux,
                dataToSend.travaux,
                dataToSend.cout_operation,
                dataToSend.zone,
                dataToSend.type_log
            )
        }
    }

    render() {
        var content

        if (this.FieldUpdated()) {
            content = (
                <button
                    className="buttonPTZ pointer regular-font fade-in"
                    onClick={() => this.CallEligibilitePtz()}
                >
                    {' '}
                    Estimer maintenant{' '}
                </button>
            )
        } else if (this.props.tech_loading_ptz) {
            content = (
                <div>
                    {' '}
                    <img
                        src="loading.gif"
                        className="loading-end-gif"
                        alt="Chargement icon"
                    />
                </div>
            )
        } else if (this.props.tech_result_ptz) {
            var result = this.props.tech_result_ptz
            content = (
                <div>
                    {result.eligible_ptz ? (
                        <div>
                            <div>
                                Vous êtes{' '}
                                <span className="green-text">
                                    <b>éligible</b>
                                </span>{' '}
                                au prêt à taux zéro (PTZ) !
                            </div>
                            <div>
                                Son montant estimé est de{' '}
                                <b>{result.ptz.montant / 100}</b> euros !
                            </div>
                            <div>
                                Et sa durée de{' '}
                                <b>{result.ptz.duree / 12} ans</b> (
                                <b>{result.ptz.differe / 12} ans</b> de différé
                                et <b>{result.ptz.amortissement / 12} ans</b> de
                                remboursement)
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div>
                                Vous n'êtes{' '}
                                <span className="red-text">
                                    <b>pas éligible</b>
                                </span>{' '}
                                au PTZ avec les informations fournies et dans
                                les conditions d'attributions actuelles.
                            </div>
                        </div>
                    )}
                </div>
            )
        }

        return (
            <div>
                <div className="Bloc fade-in bloc-full BlocPTZ">
                    <div className="titre">
                        Test d'éligibilité au prêt à taux zéro
                    </div>
                    {content}

                    <div className="alerte">{this.props.message_alerte_ptz}</div>

                </div>

            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        tech_result_ptz: state.answer['tech_result_ptz'],
        tech_loading_ptz: state.answer['tech_loading_ptz'],
        finance_revenu_fiscal_ref: state.answer['finance_revenu_fiscal_ref'],
        prj_maturite: state.answer['prj_maturite'],
        prj_localisation_ville: state.answer['prj_localisation_ville'],
        prj_type: state.answer['prj_type'],
        prj_usage: state.answer['prj_usage'],
        type_log: state.answer['prj_type_log'],
        prj_montant_travaux: state.answer['prj_montant_travaux'],
        prj_montant_construction: state.answer['prj_montant_construction'],
        prj_montant_terrain: state.answer['prj_montant_terrain'],
        prj_montant_frais_agence: state.answer['prj_montant_frais_agence'],
        prj_montant_frais_divers: state.answer['prj_montant_frais_divers'],
        prj_montant_achat: state.answer['prj_montant_achat'],
        emp_type_emprunteur: state.answer['emp_type_emprunteur'],
        emp_nb_personnes_foyer: state.answer['emp_nb_personnes_foyer'],
        message_alerte_ptz: state.answer['message_alerte_ptz'],
    }
}

export default connect(mapStateToProps)(BlocEligibilitePTZ)
